import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";

export const EIQ_ADMIN_GROUP = "eiq-admin";
export const REPORT_SENDER_USERNAME = "fidel_cinco";

export const getUserGroups = async () => {
  const session = await fetchAuthSession();
  const groups = session.tokens?.accessToken?.payload?.["cognito:groups"];
  return Array.isArray(groups) ? groups : [];
};

export const isEiqAdmin = async () => {
  const groups = await getUserGroups();
  return groups.includes(EIQ_ADMIN_GROUP);
};

export const canSendReport = async () => {
  try {
    const [user, isAdmin] = await Promise.all([getCurrentUser(), isEiqAdmin()]);
    return (
      (user && user.username === REPORT_SENDER_USERNAME) || isAdmin
    );
  } catch {
    return false;
  }
};
